import { h, type VNode } from 'vue';

import type { ColumnDef } from './types';

const EMPTY_CELL = '—';

/** Значение-фон в ячейке (прочерк, ноль) третичным цветом, чтобы данные читались первыми. */
export const mutedCell = (text: string | number): VNode => h('span', { class: 'text-(--text-tertiary)' }, text);

/** Прочерк `'—'` из `cell` колонки таблица выводит через `mutedCell`. */
export const muteEmptyCells = <TData>(columns: ColumnDef<TData>[]): ColumnDef<TData>[] =>
  columns.map((column) => {
    const { cell } = column;
    if (typeof cell !== 'function') return column;

    return {
      ...column,
      cell: (context) => {
        const output: unknown = cell(context);

        return output === EMPTY_CELL ? mutedCell(EMPTY_CELL) : output;
      },
    };
  });
